module.exports = __webpack_public_path__ + "static/media/Cooperationbg3.66784169.png";